import { createPortal } from 'react-dom';
import { useRef, useMemo } from 'react';
import { useClickAway } from 'react-use';
import { getTooltipStyles, getTooltipContentStyles } from './TooltipStyles.js';
import { useDefaultPortalRef } from '../../providers/DefaultPortalRefProvider/DefaultPortalRefProvider.js';
import { jsx, Fragment } from '@emotion/react/jsx-runtime';
import { usePopout } from '../../hooks/usePopout/usePopout.js';
import { useTheme } from '../../providers/GigerProvider/useTheme.js';

let TooltipPosition = /*#__PURE__*/function (TooltipPosition) {
  TooltipPosition["TOP"] = "top";
  TooltipPosition["BOTTOM"] = "bottom";
  TooltipPosition["LEFT"] = "left";
  TooltipPosition["RIGHT"] = "right";
  return TooltipPosition;
}({});
let TooltipAlignment = /*#__PURE__*/function (TooltipAlignment) {
  TooltipAlignment["START"] = "start";
  TooltipAlignment["CENTER"] = "center";
  TooltipAlignment["END"] = "end";
  return TooltipAlignment;
}({});
const Tooltip = _ref => {
  var _useDefaultPortalRef;
  let {
    children,
    placement = 'top',
    reference,
    onClickAway,
    isOpen,
    id,
    container: containerProp,
    ...rest
  } = _ref;
  const defaultPortal = (_useDefaultPortalRef = useDefaultPortalRef()) === null || _useDefaultPortalRef === void 0 ? void 0 : _useDefaultPortalRef.current;
  const container = containerProp || defaultPortal || window.document.body;
  const {
    setPopoutElement
  } = usePopout(reference, placement, {
    enabled: isOpen
  });
  const clickAwayRef = useRef(null);
  useClickAway(clickAwayRef, () => {
    onClickAway === null || onClickAway === void 0 ? void 0 : onClickAway();
  });
  const setRef = element => {
    setPopoutElement(element);
    clickAwayRef.current = element;
  };
  const theme = useTheme();
  const tooltipStyles = useMemo(() => getTooltipStyles(theme), [theme]);
  const tooltipContentStyles = useMemo(() => getTooltipContentStyles(theme), [theme]);
  return jsx(Fragment, {
    children: isOpen && /*#__PURE__*/createPortal(jsx("div", {
      id: id,
      role: "tooltip",
      ref: setRef,
      css: tooltipStyles,
      ...rest,
      children: jsx("div", {
        css: tooltipContentStyles,
        children: children
      })
    }), container)
  });
};

export { Tooltip, TooltipAlignment, TooltipPosition };
//# sourceMappingURL=Tooltip.js.map
